import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LanguageIcon from '@material-ui/icons/Language';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import CookieStorageService from 'services/CookieStorageService';
import { getActiveLanguageCode } from 'services/i18nService';
import ReactSelect from 'components/ReactSelect/ReactSelect';
import {
  generateID,
  isAvailableToMove,
} from 'utils/helpers';

import styles from './LanguageSelection.css';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

class LanguageSelection extends PureComponent {
  constructor(...args) {
    super(...args);

    const { prefixId } = this.props;
    this.makeId = generateID(prefixId, 'languageSelection');
  }

  handleChange = (option) => {
    const { forMobile } = this.props;
    const expires = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    const value = forMobile ? option.target.value : option.value;
    const URL = `${BASE_URL}/setlanguage?lang=${value}`;

    const urlArray = location.hostname.split('.');
    const domain = urlArray.length > 2 ? location.hostname.slice(urlArray[0].length) : `.${location.hostname}`;
    if (CookieStorageService.get('cam4_user_language')) {
      CookieStorageService.remove('cam4_user_language');
      CookieStorageService.set('cam4_user_language', value, { path: '/', expires, domain });
    } else {
      CookieStorageService.set('cam4_user_language', value, { path: '/', expires, domain });
    }
    ApiService.get(URL)
      .finally(() => {
        location.reload();
      });
  };

  parseMenuOptions = () => {
    const { availableLanguages } = this.props;
    let prevEl = {};
    const uniqueLanguages = [];
    for (let i = 0; i < availableLanguages.length; i += 1) {
      if (prevEl.code !== availableLanguages[i].code) {
        uniqueLanguages.push(availableLanguages[i]);
        prevEl = availableLanguages[i];
      }
    }

    return uniqueLanguages.map(({ code, nativeName }) => {
      return {
        value: code,
        label: nativeName,
      };
    });
  };

  render() {
    const activeLanguageCode = getActiveLanguageCode();
    const { forMobile } = this.props;
    const isLocationChangeUnavailable = !isAvailableToMove(location);

    return (
      <div className={styles.languagesDropdownOuter}>
        {forMobile ? (
          <select
            className={styles.selectMobile}
            disabled={isLocationChangeUnavailable}
            value={activeLanguageCode}
            onChange={this.handleChange}
          >
            {this.parseMenuOptions().map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ) : (
          <ReactSelect
            arrowRenderer={null}
            className={styles.languagesDropdownSelect}
            clearable={false}
            disabled={isLocationChangeUnavailable}
            id={this.makeId()}
            menuContainerStyle={{
              borderTopColor: '#ccc',
              boxShadow:
              '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
              minWidth: '121px',
              bottom: '100%',
              top: 'auto',
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              overflow: 'hidden',
            }}
            optionClassName={styles.option}
            options={this.parseMenuOptions()}
            searchable={true}
            style={{
              minWidth: '120px',
              borderRadius: '0',
              backgroundColor: 'transparent',
              color: '#f0f0f0!important',
              cursor: 'pointer',
            }}
            value={activeLanguageCode}
            wrapperClass={styles.languagesDropdown}
            onChange={this.handleChange}
          />
        )}
        <LanguageIcon
          style={{
            position: 'absolute',
            left: '10px',
            top: 'calc(50% - 12px)',
            cursor: 'pointer',
            color: '#f0f0f0',
          }}
        />
      </div>
    );
  }
}

LanguageSelection.propTypes = {
  availableLanguages: PropTypes.array.isRequired,
  prefixId: PropTypes.string.isRequired,
  forMobile: PropTypes.bool,
};

LanguageSelection.defaultProps = { forMobile: false };

export default LanguageSelection;
